import { Tabs } from 'src/design/molecules/Tabs';
import React from 'react';
import { useClosedCtcJobs } from 'src/api/queries/ctc/useClosedCtcJobs';
import { useClosedJobs } from 'src/api/queries/jobs/useClosedJobs';
import { useJobsList } from 'src/api/queries/jobs/useJobsList';
import { Header } from 'src/design/organisms/Header';
import { ClosedJobTable } from './components/ClosedJobTable';
import { JobTable } from './components/JobTable';

export const Jobs: React.FC = () => {
  const jobsQuery = useJobsList();
  const archivedQuery = useClosedJobs();
  const closedCtcQuery = useClosedCtcJobs();

  const jobs = React.useMemo(() => jobsQuery.data ?? [], [jobsQuery.data]);

  // The CTC-closed tab shows Firetrol jobs whose CTC counterpart is closed.
  const closedJobs = React.useMemo(() => {
    const closed = closedCtcQuery.data ?? [];
    return jobs.filter((j) =>
      closed.some(
        (cj) =>
          cj.wsJobNumber?.toLowerCase().trim() ===
          j.jobNumber?.toLowerCase().trim(),
      ),
    );
  }, [jobs, closedCtcQuery.data]);

  const loading = jobsQuery.isLoading;
  const fetching = archivedQuery.isLoading || closedCtcQuery.isLoading;

  return (
    <>
      <Header
        title="Jobs"
        breadcrumbProps={{
          items: [{ text: 'Jobs' }],
        }}
        helpText="Manage and view jobs in the system. Switch between active, closed, and archived jobs using the tabs below. Only jobs that you have access to are shown. Jobs must be synced from the CTC system to be shown here."
      />

      <Tabs defaultValue="active" keepMounted={false}>
        <Tabs.List>
          <Tabs.Tab value="active">Active</Tabs.Tab>
          <Tabs.Tab value="closed">CTC Closed</Tabs.Tab>
          <Tabs.Tab value="archived">Archived</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="active">
          <JobTable jobs={jobs} loading={loading} />
        </Tabs.Panel>

        <Tabs.Panel value="closed">
          <ClosedJobTable jobs={closedJobs} loading={loading || fetching} />
        </Tabs.Panel>

        <Tabs.Panel value="archived">
          <JobTable jobs={archivedQuery.data ?? []} loading={fetching} />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};
